import React from 'react'
import AboutHero from './About/AboutHero'
import AboutInformation from './About/AboutInformation'



export default function AboutPage() {
  return (
    <div>
      <AboutHero />
      <AboutInformation />
    </div>
  )
}
